/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_TotalInputs */

const vi_cashflow_total = /** @type {(inputs: Cashflow_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng`)
};

/**

* @param {Cashflow_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_total = /** @type {((inputs?: Cashflow_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_total(inputs)
});